import React from 'react'
import {Link} from 'react-router-dom'
import logo1 from '../../images/work/akns.png'
import logo2 from '../../images/work/sumenep.png'
import logo3 from '../../images/work/3.png'
import logo4 from '../../images/work/4.png'
import SectionTitle from '../SectionTitle/SectionTitle'

const Expriences = [
    {
        date: '2015 - 2017',
        logo: logo1,
        position: 'Junior Programmer',
        companyName: 'Akademi Komunitas Negeri Sumenep',
        workFrom: '',
        web: 'http://akademikomunitas.pens.ac.id/index.php/detail/detailak/3',
    },
    {
        date: '2017 - 2019',
        logo: logo2,
        position: 'Senior Programmer',
        companyName: 'Dinas Komunikasi dan Informatika Kabupaten Sumenep',
        workFrom: '(Contract Employee)',
        web: "https://sumenepkab.go.id",
    },
    {
        date: '2019 - 2020',
        logo: logo2,
        position: 'Network Engineer',
        companyName: 'Dinas Pekerjaan Umum Bina Marga Kabupaten Sumenep',
        workFrom: '(Civil Servant)',
        web: "https://binamarga.sumenepkab.go.id/",
    },
    {
        date: '2020 - Present',
        logo: logo2,
        position: 'Senior Programmer',
        companyName: 'Badan Kepegawaian dan Pengembangan Sumeber Daya Manusia Kabupaten Sumenep',
        workFrom: '(Civil Servant)',
        web: "https://bkpsdm.sumenepkab.go.id/",
    },

]


const Exprience = (props) => {
    return (
        <div className="wpo-work-area section-padding">
            <div className="container">
                <SectionTitle Title={'My Work Experience'} Subtitle={'I have worked as programmer since 2015. It started when I was a collage student.'} />
                <div className="wpo-work-wrap">
                    {Expriences.map((exprience, exp) => (
                        <div className="wpo-work-item" key={exp}>
                            <ul>
                                <li className="date">{exprience.date}</li>
                                <li className="logo"><img src={exprience.logo} height={82} alt=""/></li>
                                <li className="position">{exprience.position} <span>{exprience.companyName} <span>{exprience.workFrom}</span></span></li>
                                <li className="link"><a href={exprience.web} target="_blank">Go to website</a></li>
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
            <div className="shape-wk">
                <svg width="1500" height="1500" viewBox="0 0 1500 1500" fill="none">
                    <g opacity="0.45" filter="url(#filter0_f_39_4214)">
                        <circle cx="750" cy="750" r="200" />
                    </g>
                    <defs>
                        <filter id="filter0_f_39_4214" x="0" y="0" width="1500" height="1500"
                            filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feGaussianBlur stdDeviation="275" result="effect1_foregroundBlur_39_4212" />
                        </filter>
                    </defs>
                </svg>
            </div>
        </div>
    )
}

export default Exprience;